// extracted by mini-css-extract-plugin
export default {"search":"SearchAddresses_search__C+8SP","spinner":"SearchAddresses_spinner__Hq0j9","terms":"SearchAddresses_terms__D1zYb"};